import { MapPin } from "lucide-react";
import { BRAND } from "@/data/content";

export default function ServiceArea() {
  return (
    <section
      id="area"
      data-testid="area-section"
      className="relative bg-white py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5">
          <div className="eyebrow">Service Area</div>
          <h2 className="font-serif-display mt-4 text-4xl md:text-6xl leading-[1.05] tracking-tight text-[#111]">
            All across the <span className="italic text-[#C8A44D]">Las Vegas Valley</span>.
          </h2>
          <p className="mt-6 text-[#555] font-light leading-relaxed max-w-md">
            From Summerlin to Henderson, we serve every corner of the valley
            with the same attention to detail.
          </p>

          <ul className="mt-10 grid grid-cols-2 gap-y-4 gap-x-6">
            {BRAND.areas.map((city, i) => (
              <li
                key={city}
                data-testid={`area-city-${i}`}
                className="flex items-center gap-3 text-[#111]"
              >
                <MapPin size={15} strokeWidth={1.5} className="text-[#C8A44D]" />
                <span className="text-sm md:text-base">{city}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-7">
          <div className="relative rounded-2xl overflow-hidden border border-[#111]/10 aspect-[5/4] md:aspect-[16/12]">
            <iframe
              data-testid="area-map"
              title="Las Vegas Valley Service Area"
              src="https://www.google.com/maps?q=Las+Vegas+Valley,+Nevada&output=embed"
              className="absolute inset-0 w-full h-full"
              style={{ border: 0, filter: "grayscale(0.6) contrast(1.05)" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
            <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-black/5 rounded-2xl" />
          </div>
        </div>
      </div>
    </section>
  );
}
